<template>
  <div id="footer">

    <table id="footer_main" v-if="!isMobile">
      <tr>
        <td class="left-part">
          <!-- <div> -->
          <img src="../../assets/img/logo_01.png" class="image">
          <!-- </div> -->
        </td>
        <td>
          <div class="line"></div>
        </td>
        <td class="center-part" v-if="this.$i18n.locale=='zh'">
          <div style="width: 100%">
            <!--            <div style="min-width: 50%;float: left;line-height: 3em;">{{ $t('home.Organizer') }}: {{$t('home.lmccName')}}</div>-->
            <div style="min-width: 49%;float: left;line-height: 3em;padding-right: 1%;">{{ $t('home.Copyright') }}:
              {{ $t('home.lmccName') }}
            </div>
          </div>
          <div style="width: 100%">
            <div style="min-width: 50%;float: left;line-height: 3em;">{{
                $t('home.registration')
              }}:滇ICP备2023005766号-1
            </div>
            <div style="float: left;line-height: 3em;cursor: pointer" @click="openMail">{{ $t('home.mail') }}:
              lmlecc@lm-lesc-center.org
            </div>
          </div>

          <!--<span>{{ $t('home.tel') }}: 0871-8866888</span><br/>
          <span>{{ $t('home.RFax') }}: 0871-8866888</span><br/>-->
        </td>
        <td class="center-part-en" v-if="this.$i18n.locale=='en'">

          <!--          <span style="display: block">{{ $t('home.Organizer') }}: {{$t('home.lmccName')}}</span><br/>-->
          <span style="display: block;margin-top: 0.1vh">{{
              $t('home.Copyright')
            }}: {{ $t('home.lmccName') }}</span><br/>
          <span style="display: block;margin-top: 0.1vh">{{ $t('home.registration') }}:滇ICP备2023005766号-1</span>
          <br/>
          <!--<span>{{ $t('home.tel') }}: 0871-8866888</span><br/>
          <span>{{ $t('home.RFax') }}: 0871-8866888</span><br/>-->
          <span style="cursor: pointer" @click="openMail">{{ $t('home.mail') }}: lmlecc@lm-lesc-center.org</span>
        </td>
        <td class="right-part">
          <div class="social-icons">
            <a href="#" class="social-icon-link">
              <img src="../../assets/img/SketchPng013d354c64071fefb33e9dcfeb20c7ac87b4b4057809e1dbc1923c5bd64f9511.png"
                   alt="WeChat" class="social-icon">
            </a>
            <a href="#" class="social-icon-link">
              <img src="../../assets/img/facebook_01.png" alt="Facebook" class="social-icon">
            </a>
            <a @click="openMail" class="social-icon-link">
              <img src="../../assets/img/mail3.jpg" alt="Email" class="social-icon">
            </a>
          </div>
        </td>
      </tr>
    </table>
    <!--  手机适配  -->
    <div v-else>
      <img src="../../assets/img/logo_01.png" class="image">
      <div class="center-part" v-if="this.$i18n.locale=='zh'">
        <div style="min-width: 100%;float: left;line-height: 3em;padding-right: 1%;">{{ $t('home.Copyright') }}:
          {{ $t('home.lmccName') }}
        </div>
        <div style="min-width: 100%;float: left;line-height: 3em;">{{
            $t('home.registration')
          }}:滇ICP备2023005766号-1
        </div>
        <div style="line-height: 3em;cursor: pointer" @click="openMail">{{ $t('home.mail') }}:
          lmlecc@lm-lesc-center.org
        </div>
      </div>
      <div class="center-part-en" v-if="this.$i18n.locale=='en'">

        <span style="display: block;margin-top: 0.1vh">{{
            $t('home.Copyright')
          }}: {{ $t('home.lmccName') }}</span><br/>
        <span style="display: block;margin-top: 0.1vh">{{ $t('home.registration') }}:滇ICP备2023005766号-1</span>
        <br/>
        <span style="cursor: pointer" @click="openMail">{{ $t('home.mail') }}: lmlecc@lm-lesc-center.org</span>
      </div>
      <div class="social-icons mobile">
        <a href="#" class="social-icon-link">
          <img src="../../assets/img/SketchPng013d354c64071fefb33e9dcfeb20c7ac87b4b4057809e1dbc1923c5bd64f9511.png"
               alt="WeChat" class="social-icon">
        </a>
        <a href="#" class="social-icon-link">
          <img src="../../assets/img/facebook_01.png" alt="Facebook" class="social-icon">
        </a>
        <a @click="openMail" class="social-icon-link">
          <img src="../../assets/img/mail3.jpg" alt="Email" class="social-icon">
        </a>
      </div>

    </div>

  </div>

</template>

<script>


export default {
  name: 'mainfooter',
  components: {},
  data() {
    return {
      isMobile: false
    };
  },
  mounted() {
    this.checkScreenWidth(); // 页面加载时检查屏幕宽度
    window.addEventListener('resize', this.checkScreenWidth); // 监听窗口尺寸变化
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth);
  },
  methods: {
    openMail() {
      window.open("http://mail.lm-lesc-center.org")
    },
    checkScreenWidth() {
      this.isMobile = window.innerWidth < 800; // 判断是否为手机端
      console.log(window.innerWidth)
    }
  }
}
</script>

<style lang="less" scoped>
@media only screen and (min-width: 800px) {
  #footer {
    position: relative;
    width: 100%;
    min-height: 350px;
    /*background: #2f2f2f;*/
    background: linear-gradient(to bottom, #ffffff 3%, #7E7F81 100%);
    // margin-top: -10px;
    // margin-left: -10px;
    // margin-right: -10px;
    z-index: 10;
    padding-right: 2%;
  }

  #footer_main {
    position: relative;
    width: 70%;
    height: 100%;
    min-height: 280px;
    margin: auto;
    margin-top: 20px;
    /*border: dashed;*/
    /*background: #2f2f2f;*/
    font-size: 12px;
    font-style: normal;
    line-height: 14px;
    font-weight: bolder;

  }

  .left-part {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 280px;
    border: 1px;
  }

  .center-part {
    /*display: flex;
    justify-content: center;
    align-items: center;*/
    width: 60%;
    /*height: 280px;*/
    text-align: left;
    //  font-family: 宋体;
    font-size: 1.1em;
  }

  .center-part-en {
    /*display: flex;
    justify-content: center;
    align-items: center;*/
    width: 50%;
    /*height: 280px;*/
    text-align: left;
    font-family: "AKbalthom Freedom Plus";
  }

  .line {
    position: relative;
    border-left: 2px solid #000000;
    height: 50%;
    width: 10px;
    /* 可以根据需要调整线的高度 */
  }

  .line::after {
    content: '';
    position: absolute;
    left: 10px;
    right: 10px;
    top: 0;
    border-top: 2px solid #000000;
    /* 可以调整宽度、样式和颜色 */
  }

  .right-part {
    /*display: flex;*/
    justify-content: center;
    /*align-items: center;*/
    text-align: right;
    width: 30%;
    height: 280px;
    border: 1px;
    font-style: oblique;
  }

  .image {
    align-content: center;
    align-items: center;
    justify-content: center;

    width: 200px;
    height: auto;
  }

  .social-icons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
    margin-top: 20px;
  }

  .social-icon-link {
    display: block;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
    }
  }

  .social-icon {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}

@media only screen and (max-width: 800px) {
  #footer {
    position: relative;
    width: 100%;
    min-height: 150px;
    background: linear-gradient(to bottom, #ffffff 3%, #7E7F81 100%);
  }

  #footer_main {
    position: relative;
    width: 100%;
    height: 50px;
    min-height: 180px;
    margin: auto;
    margin-top: 20px;
  }

  .image {
    width: 100px;
  }

  .center-part-en {
    font-size: 10px !important;
    width: 100%
  }

  .center-part {
    font-size: 10px !important;
    width: 100%
  }

  .imgbox {
    margin-top: 10px;
  }

  .social-icons.mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 25px;
    margin: 20px 0;
  }

  .social-icon {
    width: 35px;
    height: 35px;
    object-fit: contain;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.social-icon-link {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comcomponents/Footer2.vue